import React, { FC } from 'react'
import { Partners, usePartner } from '@shared/lib/partner'
import { useWindowScrollPosition } from '@shared/lib/browser'
import MegafonLogo from './MegafonLogo'
import MTSLogo from './MTSLogo'
import BankirosLogo from './BankirosLogo'
import CitoraLogo from './CitoraLogo'
import PlatosferaLogo from './PlatosferaLogo'
import SmartShellLogo from './SmartShellLogo'
import IntervaleLogo from './IntervaleLogo'
import GlobalTradeLogo from './GlobalTradeLogo'

const Logo: FC = () => {
  const { partner } = usePartner()

  const isAtTop = useWindowScrollPosition()

  switch (partner) {
    case Partners.MEGAFON:
      return <MegafonLogo />
    case Partners.SMARTSHELL:
      return <SmartShellLogo />
    case Partners.GLOBALTRADE:
      return <GlobalTradeLogo />
    case Partners.INTERVALE:
      return <IntervaleLogo />
    case Partners.CITORA:
      return <CitoraLogo />
    case Partners.WILDBERRIES:
    case Partners.WILDBERRIES2:
      return null
    case Partners.VANTA:
      return null
    case Partners.PLATOSFERA:
      return <PlatosferaLogo />
    case Partners.BANKIROS:
      return <BankirosLogo />
    default:
      return <MTSLogo isAtTop={isAtTop} />
  }
}

export default Logo
